import * as React from 'react';
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent
} from '@mui/material';
import { CTextField, CButton } from '../../../../components/common/Modal';
import { AdminCredentialsSection } from './AdminCredentialsSection';
import { TestConnectionAlert } from './TestConnectionAlert';

export const RegularDatabaseWizard = ({
  type,
  hostname,
  database,
  port,
  username,
  password,
  isAdminCredential,
  onHostnameChange,
  onDatabaseChange,
  onPortChange,
  onUsernameChange,
  onPasswordChange,
  onAdminCredentialChange,
  connectionTest,
  onFinish
}) => {
  const [wizardStep, setWizardStep] = React.useState(0);

  const isStep1Valid = () => {
    return hostname && username && password && database && port;
  };

  const isStep2Valid = () => {
    return connectionTest.testResult && connectionTest.testResult.is_connected;
  };

  const handleNext = () => {
    if (wizardStep < 1) {
      setWizardStep(wizardStep + 1);
    }
  };

  const handleBack = () => {
    if (wizardStep > 0) {
      setWizardStep(wizardStep - 1);
    }
  };

  return (
    <Box sx={{ maxWidth: '100%', width: '100%', mt: 2 }}>
      <Stepper activeStep={wizardStep} orientation="vertical">
        <Step>
          <StepLabel>Setup Connection</StepLabel>
          <StepContent>
            <Card variant="outlined">
              <CardContent>
                <CTextField
                  id="hostname" 
                  label="Hostname"
                  size="small"
                  variant="outlined"
                  value={hostname}
                  onChange={onHostnameChange}
                  fullWidth
                />
                
                {!(type === 'SQLite' || type === 'Oracle') && (
                  <>
                    <CTextField
                      id="database" 
                      label="Database"
                      size="small"
                      variant="outlined"
                      value={database}
                      onChange={onDatabaseChange}
                      sx={{ marginTop: '1rem' }}
                      fullWidth
                    />
                    <CTextField
                      id="port" 
                      label="Port"
                      size="small"
                      variant="outlined"
                      value={port}
                      onChange={onPortChange}
                      sx={{ marginTop: '1rem' }}
                      fullWidth
                    />
                  </>
                )}
                
                <AdminCredentialsSection
                  isAdminCredential={isAdminCredential}
                  username={username}
                  password={password}
                  onAdminCredentialChange={onAdminCredentialChange}
                  onUsernameChange={onUsernameChange}
                  onPasswordChange={onPasswordChange}
                />
                
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <CButton
                    variant="contained"
                    onClick={handleNext}
                    disabled={!isStep1Valid()}
                  >
                    Next
                  </CButton>
                </Box>
              </CardContent>
            </Card>
          </StepContent>
        </Step>
        
        <Step>
          <StepLabel>Test Connection</StepLabel>
          <StepContent>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'medium' }}>
                  Test Connection
                </Typography>
                
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                  <CButton 
                    variant="outlined" 
                    size="small"
                    onClick={() => connectionTest.handleTestConnection(type, hostname, username, password, database, port)}
                    disabled={!hostname || !username || !password || !database || !port || connectionTest.testLoading}
                    startIcon={connectionTest.testLoading ? <CircularProgress size={16} /> : null}
                  >
                    {connectionTest.testLoading ? 'Testing...' : 'Test Connection'}
                  </CButton>
                </Box>
                
                <TestConnectionAlert testResult={connectionTest.testResult} />
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  <CButton
                    variant="outlined"
                    onClick={handleBack}
                  >
                    Back
                  </CButton>
                  <CButton
                    variant="contained"
                    onClick={onFinish}
                    disabled={!isStep2Valid()}
                  >
                    Finish
                  </CButton>
                </Box>
              </CardContent>
            </Card>
          </StepContent>
        </Step>
      </Stepper>
    </Box>
  );
};

